import { NgModule } from '@angular/core';

import { PrizmMonthPipe } from './month.pipe';

@NgModule({
  exports: [PrizmMonthPipe],
  declarations: [PrizmMonthPipe],
})
export class PrizmMonthPipeModule {}
